export type Shader = {
  fragmentShader: string;
  vertexShader: string;
  uniforms: Record<string, any>
}